import React from 'react';
import {
  FormDataConsumer,
  Labeled,
} from 'react-admin';


const Preview = ({ title, body }) => (
  <div
    style={{
      borderRadius: 12,
      background: '#eee',
      width: 304,
      fontSize: 13,
      color: '#000',
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 6,
      paddingBottom: 8,
    }}
  >
    <div
      style={{
        display: 'flex',
        marginBottom: 6,
      }}
    >
      <div
        style={{
          width: 20,
          height: 20,
          background: '#fff',
          borderRadius: 5,
        }}
      />
      <div
        style={{
          fontSize: '80%',
          textTransform: 'uppercase',
          flex: 1,
          lineHeight: '20px',
          paddingLeft: 8,
        }}
      >
        My IPO
      </div>
    </div>
    {title && (
      <div
        style={{
          fontWeight: 'bold',
          lineHeight: '18px',
          marginBottom: 4,
        }}
      >
        {title}
      </div>
    )}
    <div
      style={{
        minHeight: '1em',
      }}
    >
      {body}
    </div>
  </div>
);


export const PreviewField = ({ record }) => <Preview {...record} />;


export const PreviewFieldForCreateForm = () => (
  <Labeled label="Preview">
    <FormDataConsumer>
      {({ formData }) => <Preview {...formData} />}
    </FormDataConsumer>
  </Labeled>
);



// WEBPACK FOOTER //
// ./src/components/PushNotification/PreviewField.js